import React from "react";
import { Devices } from "Components/overview";
import { withTranslation } from "react-i18next";
import { Box } from "@mui/material";


const OverviewContainer = ({ isCompact }) => {
  return (
    <Box sx={{ height: "100%", overflow: "auto" }}>
      <Devices isCompact={isCompact} />
    </Box>
  );
};

export default withTranslation("common")(OverviewContainer);
